import { useState } from "react";
import { Link } from "react-router-dom";
import {
  __MEDIAICON,
  __MEDIAICONBLACK,
  _EVENTICON,
  _EVENTICONBLACK,
} from "../../data/icons";
import aquaLogo from "../../images/logo/aquavesc-logo.png";
import hydraLogo from "../../images/logo/hydreualys-logo.png";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

const HydreaulysContentData = [
  {
    id: "1",
    icon: _EVENTICON || "",
    hoverIcon: _EVENTICONBLACK || "",
    title: "Événements",
    link: process.env.REACT_APP_HYDREAULYS_EVENTS_URL,
    desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa repudiandae sit est laudantium quibusdam nam dolore. Illo  facilis provident eaque labore, assumenda cumque omnis fugit excepturi minus. Aut, placeat asperiores.",
  },

  {
    id: "2",
    icon: __MEDIAICON || "",
    hoverIcon: __MEDIAICONBLACK || "",
    title: "Médiathèque",
    link: process.env.REACT_APP_HYDREAULYS_MEDIA_URL,
    desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa repudiandae sit est laudantium quibusdam nam dolore. Illo  facilis provident eaque labore, assumenda cumque omnis fugit excepturi minus. Aut, placeat asperiores.",
  },
];
const AquavescContentData = [
  {
    id: "1",
    icon: _EVENTICON || "",
    hoverIcon: _EVENTICONBLACK || "",
    title: "Événements",
    link: process.env.REACT_APP_AQUAVESC_EVENTS_URL,
    desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa repudiandae sit est laudantium quibusdam nam dolore. Illo  facilis provident eaque labore, assumenda cumque omnis fugit excepturi minus. Aut, placeat asperiores.",
  },

  {
    id: "2",
    icon: __MEDIAICON || "",
    hoverIcon: __MEDIAICONBLACK || "",
    title: "Médiathèque",
    link: process.env.REACT_APP_AQUAVESC_MEDIA_URL,
    desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa repudiandae sit est laudantium quibusdam nam dolore. Illo  facilis provident eaque labore, assumenda cumque omnis fugit excepturi minus. Aut, placeat asperiores.",
  },
];

const Portail = () => {
  const [hydraHoveredIndex, setHydraHoveredIndex] = useState<number | null>(
    null
  );
  const [aquaHoveredIndex, setAquaHoveredIndex] = useState<number | null>(null);

  return (
    <div className="px-4 py-12 mt-24 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        {/* Header Section */}
        <div className="mb-16 text-center">
          <h1 className="mb-6 text-4xl font-bold text-blue-900">
            En faveur du développement durable
          </h1>
          <p className="max-w-4xl mx-auto text-lg leading-relaxed text-blue-400">
            La responsabilité des syndicats peut avoir été confiée, dans le
            cadre d'une délégation de service public, à un « délégataire ». Les
            factures reçues par le consommateur sont alors émises par ce
            dernier.
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
          {/* HYDREAULYS Section */}
          <div className="p-8 bg-white shadow-lg rounded-2xl">
            {/* Logo and Title */}
            <div className="mb-8 text-center">
              <div className="flex justify-center mb-4">
                <div className="flex items-center justify-center ">
                  <img src={hydraLogo} alt="HYDREAULYS" />
                </div>
              </div>
              <a
                href={process.env.REACT_APP_HYDREAULYS_URL}
                target="_blank"
                rel="noreferrer"
              >
                <button className="group relative px-10 py-4 bg-gradient-to-r from-primary to-primary/80 text-white font-bold uppercase rounded-2xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-primary/50">
                  {/* Shine effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>

                  {/* Content */}
                  <div className="relative flex items-center gap-2">
                    <span className="text-base tracking-wide">Hydreaulys</span>
                    <svg
                      className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </div>
                </button>
              </a>
            </div>

            {/* Description */}
            <div className="mb-8 text-center">
              <p className="font-medium text-gray-700">
                Établissement territorial en charge de l'assainissement des eaux
                usées et pluviales
              </p>
            </div>

            {/* Icons */}
            <div className="flex justify-center space-x-8">
              <div className="grid grid-cols-1 gap-8 mt-8 md:grid-cols-2 place-items-center">
                {HydreaulysContentData.map((item, index) => (
                  <a
                    href={item.link}
                    key={item.id}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Card
                      className="hover:bg-[#3CC6F7] group w-[180px] h-[180px] flex flex-col"
                      onMouseEnter={() => setHydraHoveredIndex(index)}
                      onMouseLeave={() => setHydraHoveredIndex(null)}
                    >
                      <CardHeader className="flex items-center justify-center flex-1 pb-2">
                        <CardTitle className="flex justify-center">
                          <svg
                            width="40"
                            height="40"
                            viewBox="0 0 83 83"
                            xmlns="http://www.w3.org/2000/svg"
                            dangerouslySetInnerHTML={{
                              __html:
                                hydraHoveredIndex === index
                                  ? item.hoverIcon
                                  : item.icon,
                            }}
                          />
                        </CardTitle>
                      </CardHeader>
                      <CardContent className="px-3 pb-4 text-center">
                        <p className="mb-2 text-sm font-bold leading-tight group-hover:text-white">
                          {item.title}
                        </p>
                        <p className="text-xs text-primary group-hover:text-white">
                          Voir plus {">>"}
                        </p>
                      </CardContent>
                    </Card>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* AQUAVESC Section */}
          <div className="p-8 bg-white shadow-lg rounded-2xl">
            {/* Logo and Title */}
            <div className="mb-8 text-center">
              <div className="flex justify-center mb-4">
                <div className="flex items-center justify-center ">
                  <img src={aquaLogo} alt="AQUAVESC" />
                </div>
              </div>

              <a
                href={process.env.REACT_APP_AQUAVESC_URL}
                target="_blank"
                rel="noreferrer"
              >
                <button className="group relative px-10 py-4 bg-gradient-to-r from-secondary to-secondary/80 text-white font-bold uppercase rounded-2xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-secondary/50">
                  {/* Shine effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>

                  {/* Content */}
                  <div className="relative flex items-center gap-2">
                    <span className="text-base tracking-wide">Aquavesc</span>
                    <svg
                      className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </div>
                </button>
              </a>
            </div>

            <div className="mb-8 text-center">
              <p className="font-medium text-gray-700">
                Établissement territorial en charge de la production et de la
                distribution de l’eau potable
              </p>
            </div>

            {/* Icons */}

            <div className="flex justify-center space-x-8">
              <div className="grid grid-cols-1 gap-8 mt-8 md:grid-cols-2 place-items-center">
                {AquavescContentData.map((item, index) => (
                  <a
                    href={item.link}
                    key={item.id}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Card
                      className="hover:bg-[#3CC6F7] group w-[180px] h-[180px] flex flex-col"
                      onMouseEnter={() => setAquaHoveredIndex(index)}
                      onMouseLeave={() => setAquaHoveredIndex(null)}
                    >
                      <CardHeader className="flex items-center justify-center flex-1 pb-2">
                        <CardTitle className="flex justify-center">
                          <svg
                            width="40"
                            height="40"
                            viewBox="0 0 83 83"
                            xmlns="http://www.w3.org/2000/svg"
                            dangerouslySetInnerHTML={{
                              __html:
                                aquaHoveredIndex === index
                                  ? item.hoverIcon
                                  : item.icon,
                            }}
                          />
                        </CardTitle>
                      </CardHeader>
                      <CardContent className="px-3 pb-4 text-center">
                        <p className="mb-2 text-sm font-bold leading-tight group-hover:text-white">
                          {item.title}
                        </p>
                        <p className="text-xs text-primary group-hover:text-white">
                          Voir plus {">>"}
                        </p>
                      </CardContent>
                    </Card>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portail;
